import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useOrg } from './OrgSelector';
import AccessDenied from './AccessDenied';

export default function ProtectedRoute({ children, requiredPermission = null }) {
  const { isAuthenticated, loading, hasPermission } = useAuth();
  const { activeOrg } = useOrg();
  const location = useLocation();
  const requiredPermissions = Array.isArray(requiredPermission)
    ? requiredPermission.filter(Boolean)
    : requiredPermission
      ? [requiredPermission]
      : [];

  if (loading) {
    return (
      <div style={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#6b7d8f',
        fontFamily: "'IBM Plex Mono', monospace",
      }}>
        Verification de la session...
      </div>
    );
  }

  if (!isAuthenticated) {
    const returnTo = location.pathname + location.search;
    try { sessionStorage.setItem('returnTo', returnTo); } catch {}
    return <Navigate to={`/login?returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }

  if (requiredPermissions.length && !requiredPermissions.some(permission => hasPermission(permission, activeOrg?.code))) {
    return <AccessDenied permissions={requiredPermissions} />;
  }

  return children;
}
